import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

export type TruncatePosition = 'start' | 'middle' | 'end';

@Component({
  selector: 'piqet-angular-text-preview',
  templateUrl: './text-preview.component.html',
  styleUrls: ['./text-preview.component.scss'],
})
export class TextPreviewComponent implements OnInit, OnChanges {
  @Input() text = '';
  @Input() labelText = 'Functional unit text preview';
  @Input() textPrefix = 'Accordingly, the FU for this study is "';
  @Input() textSuffix = '."';
  @Input() highlightText = true;
  @Input() maxLength = 50;
  @Input() truncatePosition: TruncatePosition = 'middle';
  @Input() truncateIndicator = '...';
  formattedText = '';

  ngOnInit() {
    this.updateFormattedText();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['text'] ||
      changes['maxLength'] ||
      changes['truncatePosition'] ||
      changes['highlightText'] ||
      changes['textPrefix'] ||
      changes['textSuffix']
    ) {
      this.updateFormattedText();
    }
  }

  private updateFormattedText(): void {
    if (!this.text) {
      this.text = 'your text goes here';
    }

    let processedText = this.text;

    // Apply truncation if text exceeds maxLength
    if (this.text.length > this.maxLength) {
      processedText = this.truncateText(this.text, this.maxLength, this.truncatePosition);
    }

    // Apply highlighting if enabled
    if (this.highlightText) {
      processedText = `<span class="highlight">${processedText}</span>`;
    }

    // Combine with prefix and suffix
    this.formattedText = `${this.textPrefix}${processedText}${this.textSuffix}`;
  }

  private truncateText(text: string, maxLength: number, position: TruncatePosition): string {
    if (text.length <= maxLength) {
      return text;
    }

    const indicator = `<span class="truncate-indicator">${this.truncateIndicator}</span>`;

    switch (position) {
      case 'start':
        return indicator + text.slice(-(maxLength - this.truncateIndicator.length));

      case 'end':
        return text.slice(0, maxLength - this.truncateIndicator.length) + indicator;

      case 'middle': {
        const halfLength = Math.floor((maxLength - this.truncateIndicator.length) / 2);
        const start = text.slice(0, halfLength);
        const end = text.slice(-halfLength);
        return start + indicator + end;
      }

      default:
        return text;
    }
  }
}
